import { render, staticRenderFns } from "./ManifestsHead.vue?vue&type=template&id=35a45ac6&scoped=true"
import script from "./ManifestsHead.vue?vue&type=script&lang=js"
export * from "./ManifestsHead.vue?vue&type=script&lang=js"
import style0 from "./ManifestsHead.vue?vue&type=style&index=0&id=35a45ac6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a45ac6",
  null
  
)

export default component.exports